
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isArray, filter, clone } from 'lodash';
import Button from '@material-ui/core/Button';
import styled from "styled-components";
import { withAsync } from './withAsync';


const StyledButton = styled(Button)`
  &.active {
    background: #000;
    color: #fff;
  }
  margin: 0 5px 5px 0;
`;


export class SelectManyButtonWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    onOptionAdd: PropTypes.func,
    onOptionDelete: PropTypes.func,
    emptyValue: PropTypes.any,
    isOptionDisabled: PropTypes.func,
  };

  static defaultProps = {
    optionLabel: 'label',
    optionValue: 'value',
    emptyValue: []
  };

  getOptionLabel = (option) => {
    return option[this.props.optionLabel];
  };

  getOptionValue = (option) => {
    return option[this.props.optionValue];
  };

  handleChange = (option) => {
    const { onChange, onOptionAdd, onOptionDelete } = this.props;
    let value = clone(this.props.value);
    if (value && isArray(value)) {
      const index = value.indexOf(this.getOptionValue(option));
      if (index === -1) {
        value.push(this.getOptionValue(option));
        if (onOptionAdd) {
          onOptionAdd(option);
        }
      }
      else {
        value.splice(index, 1);
        if (onOptionDelete)
          onOptionDelete(option);
      }
    }
    else {
      value = [];
      value.push(this.getOptionValue(option));
    }

    if (onChange)
      onChange(value);
  };

  render() {
    const { value, isOptionDisabled, options } = this.props;

    let selectedOptions = [];
    let selectedValues = [];
    if (value !== null && value !== undefined && value !== []) {
      const getOptionValue = this.getOptionValue;
      selectedOptions = filter(options, function (o) {
        return value.indexOf(getOptionValue(o)) !== -1;
      });
    }

    for (const index in selectedOptions) {
      selectedValues.push(this.getOptionValue(selectedOptions[index]));
    }

    return (
      <React.Fragment>
        {options.map((option) => (
          <StyledButton
            variant="outlined"
            key={this.getOptionValue(option)}
            onClick={() => this.handleChange(option)}
            size={'small'}
            className={selectedValues.indexOf(this.getOptionValue(option)) !== -1 ? 'active' : undefined}
            disabled={selectedValues.indexOf(this.getOptionValue(option)) !== -1 ? false : isOptionDisabled ? isOptionDisabled(option) : false}
          >
            {this.getOptionLabel(option)}
          </StyledButton>
        ))}
      </React.Fragment>
    );
  }
}


export const AsyncSelectManyButtonWidget = withAsync(SelectManyButtonWidget);
